"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const EditorFactory_1 = require("../EditorFactory");
const React = require("react");
const classNames = require("classnames");
const core_1 = require("@blueprintjs/core");
const mobx_1 = require("mobx");
const createDefaultNode_1 = require("../createDefaultNode");
const mobx_react_1 = require("mobx-react");
const Context_1 = require("../Context");
const select_1 = require("@blueprintjs/select");
const utils_1 = require("./utils");
const UnionSelector_1 = require("./UnionSelector");
class ObjectEditorFactory extends EditorFactory_1.EditorFactory {
    getEditors(node, factory, context) {
        if (node.kind !== "object") {
            return [];
        }
        return [
            {
                isSingleLine: false,
                priority: 100,
                render: () => (React.createElement(ObjectEditor, { node: node, factory: factory, context: context }))
            }
        ];
    }
}
exports.ObjectEditorFactory = ObjectEditorFactory;
let ObjectEditor = class ObjectEditor extends React.Component {
    render() {
        const { node, factory, context } = this.props;
        return (React.createElement("div", { className: classNames("component-ObjectEditor", `level-${context.get(Context_1.objectContext).depth}`) }, Object.values(node.properties)
            .filter(p => p.propertyInfo.optional ||
            p.propertyInfo.type.resolveDefinition().kind !==
                "literal")
            .map((v, idx) => (React.createElement(ObjectPropertyEditor, { key: idx, property: v, factory: factory, context: context })))));
    }
};
ObjectEditor = __decorate([
    mobx_react_1.observer
], ObjectEditor);
let ObjectPropertyEditor = class ObjectPropertyEditor extends React.Component {
    handleChange(event) {
        const c = this.props.property.container;
        if (event.currentTarget.checked) {
            c.node = createDefaultNode_1.createDefaultNode(c.expectedType);
        }
        else {
            c.node = undefined;
        }
    }
    render() {
        const { property: p, factory, context } = this.props;
        const types = p.container.expectedType.resolveUnion();
        // assert types.length > 0
        const inner = p.container.node
            ? factory.getBestEditor(p.container.node, factory, context.withUpdated(Context_1.objectContext, c => c.increaseDepth()))
            : undefined;
        const singleLine = 
        //!p.propertyInfo.optional &&
        inner && inner.isSingleLine && types.length === 1;
        const innerEditor = inner && inner.render();
        const TypeSelect = select_1.Select.ofType();
        const currentType = p.container.node
            ? p.container.node.sourceType
            : undefined;
        const headerContent = (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { flex: 1 } }, singleLine ? innerEditor : undefined),
            types.length > 1 && (React.createElement("div", { style: { paddingRight: 16 } },
                React.createElement(UnionSelector_1.UnionSelector, { container: p.container }, name => (React.createElement("h3", { className: "type-name bp3-heading" }, name))))),
            p.propertyInfo.optional && (React.createElement("div", { style: { paddingRight: 16 } },
                React.createElement(core_1.Switch, { style: { margin: 0 }, checked: !!p.container.node, innerLabel: p.container.node ? "Defined" : "Undefined", large: true, onChange: this.handleChange })))));
        const mainContent = singleLine ? undefined : innerEditor;
        return (React.createElement("div", { className: classNames("component-ObjectPropertyEditor") },
            React.createElement("div", { className: "part-header" },
                React.createElement("div", { className: "part-name" },
                    React.createElement("h5", { className: "bp3-heading" }, utils_1.camelCaseToCapitalized(p.name))),
                headerContent && (React.createElement("div", { className: "part-headerContent" }, headerContent))),
            mainContent && React.createElement("div", { className: "part-main" }, mainContent)));
    }
};
__decorate([
    mobx_1.action.bound
], ObjectPropertyEditor.prototype, "handleChange", null);
ObjectPropertyEditor = __decorate([
    mobx_react_1.observer
], ObjectPropertyEditor);
//# sourceMappingURL=ObjectEditorFactory.js.map